import { Activity, Cpu, Edit3, MoreVertical, Trash2 } from 'lucide-react';
import React from 'react';
import { AgentData } from '../../../../../../types/Agent.types';

interface AgentCardProps {
  agent: AgentData;
  isSelected: boolean;
  isActionMenuOpen: boolean;
  onSelect: (agent: AgentData) => void;
  onActionMenuToggle: (agentId: string | null) => void;
  onEdit: (agent: AgentData) => void;
  onDelete: (agent: AgentData) => void;
}

export const AgentCard: React.FC<AgentCardProps> = ({
  agent,
  isSelected,
  isActionMenuOpen,
  onSelect,
  onActionMenuToggle,
  onEdit,
  onDelete,
}) => {
  return (
    <div
      onClick={(e) => { e.stopPropagation(); onSelect(agent); }}
      className={`agent-card ${isSelected ? "selected" : ""}`}
    >
      <div className="agent-card-bg-decoration" />

      <div className="agent-card-header">
        <div className="agent-card-identity">
          <div className={`agent-card-icon-wrapper ${agent.status}`}>
            <Cpu size={20} />
          </div>
          <div>
            <h4 className="agent-card-title">{agent.name}</h4>
            <span className="agent-card-subtitle">{agent.id} | v{agent.version}</span>
          </div>
        </div>
        <div className="agent-card-status-group">
          <div className={`agent-card-status-badge ${agent.status}`}>
            {agent.status}
          </div>
          <div className="agent-card-action-btn-wrapper">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onActionMenuToggle(isActionMenuOpen ? null : agent.id);
              }}
              className={`agent-card-action-btn ${isActionMenuOpen ? "active" : ""}`}
            >
              <MoreVertical size={14} />
            </button>

            {isActionMenuOpen && (
              <div
                className="agent-card-action-menu"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => onEdit(agent)}
                  className="agent-card-action-item"
                >
                  <Edit3 size={12} className="agent-card-action-icon edit-icon" />
                  Editar
                </button>
                <button
                  onClick={() => onDelete(agent)}
                  className="agent-card-action-item delete"
                >
                  <Trash2 size={12} className="agent-card-action-icon" />
                  Eliminar
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="agent-card-metrics">
        <div className="agent-card-metrics-grid">
          <div className="agent-card-metric-item">
            <span className="agent-card-metric-label">Eficiencia</span>
            <div className="agent-card-metric-bar-container">
              <div className="agent-card-metric-bar-bg">
                <div className="agent-card-metric-bar-fill" style={{ width: `${agent.efficiency}%` }} />
              </div>
              <span className="agent-card-metric-value">{agent.efficiency}%</span>
            </div>
          </div>
          <div className="agent-card-metric-item">
            <span className="agent-card-metric-label">Tareas_OK</span>
            <div className="agent-card-metric-value">{agent.tasksCompleted}</div>
          </div>
        </div>

        <div className="agent-card-footer">
          <div className="agent-card-footer-label-wrapper">
            <Activity size={12} className="agent-card-footer-icon" />
            <span className="agent-card-footer-label">Última_Actividad</span>
          </div>
          <span className="agent-card-footer-value">{new Date(agent.lastActivity).toLocaleTimeString()}</span>
        </div>
      </div>
    </div>
  );
};
